import * as React from "react";
import {
    reduxForm,
    InjectedFormProps,
    formValueSelector,
} from 'redux-form'
import {AppState} from "../../../../store/app_state";
import {Action, Dispatch} from "redux";
import {connect} from "react-redux";

import {frontEndConfig} from '../../../../../config/config';
import {Contract} from "../../../../../domain/model/contract";
import {Customer,
} from "../../../../../domain/model/customer";

import styled from "styled-components";
import {
    ConstColor} from "../../../../../config/styles_const/styles_const";
import ParagraphSup from "../../../../common/atom/text/paragraph_sup";
import BtnCorporateMiddle from "../../../../common/atom/btn/btn_corporate_middle";
import SubmitButtonWrapper from "../../../../common/atom/wrapper/submit_btn_wrapper/submit_btn_wrapper";
import BtnCorporateLarge from "../../../../common/atom/btn/btn_corporate_large";
import ContractCustomerContent from "../share/contract_customer_content";

const uploadFileMaxSize = frontEndConfig.uploadFileMaxSize;

const validate = (values: any) => {
    const errors: any = {};
    return errors
};

interface IStateProps {
    initialValues: {
        contract: Contract | null;
        customer: Customer | null;
        fileURLFileObject?: File;
    } | undefined;
    formValues: any;
}

interface IProps extends IStateProps {
}

interface IState {
    imageError: string | null;
}

export class ClientContractMainCreateForm extends React.Component<IProps & InjectedFormProps<{}, IProps>, IState> {

    constructor(props: IProps & InjectedFormProps<{}, IProps>) {
        super(props);

        this.state = {
            imageError: null,
        };

    };

    public render(): JSX.Element {

        const {handleSubmit, submitting} = this.props;

        const contract: Contract | null = this.props.initialValues.contract;

        const customer: Customer | null = this.props.initialValues.customer;

        if (!contract || !customer) {
            return (<div/>)
        }

        let res: JSX.Element;


        // 新規作成
        res = (
            <React.Fragment>

                <ContractCustomerContent customer={customer}/>

                <form
                    name="ClientContractCreateForm"
                    onSubmit={handleSubmit}>

                    <InputWrapper>

                        {(this.props.formValues) && (
                            <ParagraphSup>
                                UploadFile有り
                            </ParagraphSup>)}

                        <input
                            accept="application/pdf,
                                    application/vnd.ms-powerpoint,
                                    application/vnd.openxmlformats-officedocument.presentationml.presentation,
                                    application/msword,
                                    application/vnd.openxmlformats-officedocument.wordprocessingml.document,
                                    application/vnd.ms-excel,
                                    application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                            id="contained-button-file"
                            multiple={false}
                            type="file"
                            onChange={this.handleOnChange}
                        />
                        {(this.state.imageError) && (<mark>{this.state.imageError}</mark>)}
                        <label htmlFor="contained-button-file">
                            <BtnCorporateMiddle
                                as={"span"}
                                widthSize={"200px"}
                            >
                                契約書をアップロード
                            </BtnCorporateMiddle>
                        </label>
                    </InputWrapper>

                    <InputTextWrapper>
                        <InputText>
                            ※契約書のアップロードは任意です
                        </InputText>
                    </InputTextWrapper>

                    <SubmitButtonWrapper>
                        <BtnCorporateLarge
                            name="ClientContractCreateForm-submit"
                            type="submit"
                            widthSize="200px"
                            disabled={submitting}>送信する</BtnCorporateLarge>
                    </SubmitButtonWrapper>

                </form>
            </React.Fragment>
        );

        return (res)
    };

    private handleOnChange = (e: any) => {
        const target: HTMLInputElement = e.target as HTMLInputElement;
        const file: File | null = (target.files) ? target.files.item(0) : null;

        try {
            this.setState({imageError: null});
            if (file) {
                if (file.size > uploadFileMaxSize) {
                    throw new Error("ファイルサイズオーバ");
                } else {
                    this.props.change("fileURLFileObject", file);
                }
            }
        } catch (error) {
            this.setState({imageError: error.message});
        }
    }


}

const selector = formValueSelector('ClientContractCreateForm');

const mapStateToProps = (state: AppState) => {
    return {
        formValues: selector(state, 'fileURLFileObject'),
    };
};

const mapDispatchToProps = (dispatch: Dispatch<Action>) => {
    return {};
};


export default reduxForm({
        form: 'ClientContractCreateForm',
        validate,
    }
)(connect(mapStateToProps, mapDispatchToProps)(ClientContractMainCreateForm));

const InputWrapper = styled.div`
    text-align: center;
    & > input {
        display: none;
    }
    margin-bottom: 10px;
`;

const InputTextWrapper = styled.div`
    margin-bottom: 50px;
    text-align: center;
`;

const InputText = styled(ParagraphSup)`
    color: ${ConstColor.Gray}
`;




// WEBPACK FOOTER //
// ./src/presentation/component/client/contract/create/client_contract_main_create_form.tsx